export enum SoAdminActionTypes {
  UPDATE_SESSION = "UPDATE_SESSION",
}
